// Components
import { Button } from '@tracklib/kit'
import LicenseButton from 'components/track/licensebutton'

// Types
import { UserSong } from 'types'
import { UserSongStep } from 'modules/usersongs/selectors'

// Utils
import { TRACKLIB_CONTACT_SUPPORT_PAGE } from '@constants'

import type { Song } from 'types'

import styles from './actionbutton.css'

type ActionButtonProps = {
  userSong: UserSong
  steps: Array<UserSongStep>
}

const ActionButton = ({ userSong, steps }: ActionButtonProps): JSX.Element | null => {
  const { state, samples, id } = userSong
  if (state === 'TERMINATED' || state === 'INVALID') {
    return (
      <Button href={TRACKLIB_CONTACT_SUPPORT_PAGE} className={styles.button}>
        Contact support
      </Button>
    )
  }
  if (state === 'UNLICENSED') {
    return <LicenseButton song={samples[0].song as Song} userSong={userSong} className={styles.button} />
  }
  const currentStep = steps.find(step => !step.completed)
  if (currentStep) {
    return (
      <Button to={currentStep.modal} query={{ userSongId: id }} modal className={styles.button} datatesting="button_current_step">
        {currentStep.cta}
      </Button>
    )
  }
  if (state !== 'ACTIVE') {
    return (
      <Button to={`/yoursongs/${id}/license/#activate`} className={styles.button} datatesting="button_activate_usersong">
        Activate<span className={styles.mobileHidden}>license</span>
      </Button>
    )
  }
  return null
}

export default ActionButton
